var _defs, _rect, _text, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_168_1",
    "data-name": "Component 168 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28370",
    "data-name": "Rectangle 28370",
    width: 10,
    height: 10,
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28371",
    "data-name": "Rectangle 28371",
    width: 40,
    height: 20,
    rx: 5,
    fill: "#ef0b0a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "HOT",
    transform: "translate(15 14)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HOT"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker",
    transform: "translate(2 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79000",
    "data-name": "Group 79000",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66101",
    "data-name": "Path 66101",
    d: "M8.556,6.213a.417.417,0,0,0-.228-.372,11.78,11.78,0,0,0-1.172-.514,2.529,2.529,0,0,1-1.5-1.519,12.17,12.17,0,0,0-.507-1.19.416.416,0,0,0-.747,0A12.185,12.185,0,0,0,3.9,3.808a2.528,2.528,0,0,1-1.5,1.52,11.816,11.816,0,0,0-1.174.515.417.417,0,0,0,0,.743A11.758,11.758,0,0,0,2.4,7.1,2.529,2.529,0,0,1,3.9,8.617a12.265,12.265,0,0,0,.506,1.189.416.416,0,0,0,.747,0,11.951,11.951,0,0,0,.506-1.188,2.532,2.532,0,0,1,1.5-1.52,11.815,11.815,0,0,0,1.174-.514.417.417,0,0,0,.228-.372",
    transform: "translate(-0.584 -1.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66102",
    "data-name": "Path 66102",
    d: "M16.776,4.285a3.161,3.161,0,0,0,.314.138.3.3,0,0,1,.179.181,3.155,3.155,0,0,0,.135.318.416.416,0,0,0,.373.233h0a.416.416,0,0,0,.373-.232,3.286,3.286,0,0,0,.135-.317.3.3,0,0,1,.178-.183,3.113,3.113,0,0,0,.315-.138.416.416,0,0,0,0-.743,3.37,3.37,0,0,0-.313-.138.3.3,0,0,1-.179-.182,3.272,3.272,0,0,0-.136-.318.417.417,0,0,0-.373-.232h0a.416.416,0,0,0-.373.233,3.283,3.283,0,0,0-.134.316.3.3,0,0,1-.178.182,3.172,3.172,0,0,0-.315.138.416.416,0,0,0,0,.742Z",
    transform: "translate(-9.653 -1.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66103",
    "data-name": "Path 66103",
    d: "M18.69,15.643a3.875,3.875,0,0,0-.391-.171.5.5,0,0,1-.3-.3,4.118,4.118,0,0,0-.169-.4.416.416,0,0,0-.747,0,4.109,4.109,0,0,0-.168.394.5.5,0,0,1-.3.3,3.8,3.8,0,0,0-.392.173.417.417,0,0,0,0,.743,4.014,4.014,0,0,0,.391.172.5.5,0,0,1,.3.3,4,4,0,0,0,.169.4.416.416,0,0,0,.747,0,4.024,4.024,0,0,0,.169-.4.5.5,0,0,1,.3-.3,3.965,3.965,0,0,0,.391-.172.417.417,0,0,0,0-.743Z",
    transform: "translate(-9.335 -8.482)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.25a904214892f9f2840ce75f2b88cdf4.svg";
export { ForwardRef as ReactComponent };